import { render, staticRenderFns } from "./ClinicalTrialDetail.vue?vue&type=template&id=179a9b56&scoped=true&"
import script from "./ClinicalTrialDetail.vue?vue&type=script&lang=ts&"
export * from "./ClinicalTrialDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ClinicalTrialDetail.vue?vue&type=style&index=0&id=179a9b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a9b56",
  null
  
)

export default component.exports